import { SessionService } from "@/services/session.service";
import { ROLES, STATUS } from "@/constants";
import Vue from "vue";
const state = {
  session: {
    token: "",
    ticket: "",
    room: "",
    role: "",
  },
  status: STATUS.NOT_CONNECTED,
  qrUrl: "",
  users: [],
  videoReady: false,
};
const getters = {
  users(state) {
    return state.users;
  },
  session(state) {
    return state.session;
  },
  qrLink(state) {
    return state.qrUrl;
  },
  videoReady(state) {
    return state.videoReady;
  },
  connectionStatus(state) {
    return state.status;
  },
};
const mutations = {
  setSession(state, session) {
    if (session) {
      localStorage.setItem("session_token", session.token);
      localStorage.setItem("session_ticket", session.ticket);
    }
    state.session = session;
  },
  setUsers(state, payload) {
    state.users = payload;
  },
  setQrLink(state, payload) {
    state.qrUrl = payload;
  },
  setRole(state, payload) {
    state.session.role = payload;
  },
  setVideoReady(state, payload) {
    state.videoReady = payload;
  },
  setStatus(state, payload) {
    state.status = payload;
  },
};
const actions = {
  changeVideoStatus({ commit }, val) {
    commit("setVideoReady", val);
  },
  changeConnectionStatus({ commit }, val) {
    commit("setStatus", val);
  },
  clearSession({ commit }) {
    commit("setSession", {
      token: "",
      ticket: "",
      room: "",
      role: "",
    });
  },
  newSession({ commit }, data) {
    return new Promise((resolve) => {
      SessionService.NewSession(data.deviceId)
        .then((r) => {
          const session = {
            token: r.data.result.token,
            ticket: r.data.result.ticket,
            room: data.room,
            role: ROLES.HOST,
          };
          const launcher =
            data.os === "ios" ? "ios-launcher" : "android-launcher";
          commit(
            "setQrLink",
            `${process.env.VUE_APP_SITE_URL}/${launcher}/${data.deviceId}?token=${session.token}&ticket=${session.ticket}`
          );
          commit("setSession", session);
          resolve(session);
        })
        .catch(() => {
          resolve(null);
        });
    });
  },
  changeRole({ commit }, role) {
    commit("setRole", role);
  },
  changeQrUrl({ commit }, url) {
    commit("setQrLink", url);
  },
  joinSession({ commit }, data) {
    return new Promise((resolve, reject) => {
      SessionService.JoinSession(data)
        .then((r) => {
          commit("setDevice", {
            id: r.data.result.id,
            deviceName: r.data.result.name,
            deviceOs: r.data.result.os,
            osVersion: r.data.result.version,
            signalPort: r.data.result.signalPort,
            deviceToken: r.data.result.deviceToken,
          });
          const session = {
            token: data.token,
            ticket: data.ticket,
            room: r.data.result.liveWatchId,
            role: ROLES.VIEWER,
            name: data.name,
          };
          commit("setSession", session);
          resolve(session);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  destroySession({ commit }) {
    const session = {
      token: localStorage.getItem("session_token"),
      ticket: localStorage.getItem("session_ticket"),
      accessToken: localStorage.getItem("access_token"),
    };
    SessionService.DestroySession(session).then(() => {
      commit("setSession", {
        token: "",
        ticket: "",
        room: "",
        role: "",
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  emitMixPanelEvent({ state, commit, rootState }, payload) {
    if (process.env.VUE_APP_MIX_ENABLED !== "enabled") return;
    setTimeout(() => {
      if (rootState.auth.user) {
        payload.data.user = rootState.auth.user.id;
      }
      Vue.prototype.$mixpanel.track(payload.event, payload.data);
    }, 2000);
  },
  updateUsers({ commit }, payload) {
    commit("setUsers", payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
